/* eslint-disable */
export class GroupMember {
    groups_uid: string;
    uid: string;
    email: string;
    name: string;
    last_name: string;
    company: string;
    phone: string;
    access: string;
}
